import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { TabHeader } from '../../shared_components/tab-header/tab-header.component';

@Component({
    selector: 'kt-form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent implements OnChanges {
    @Input() hasFormErrors: boolean;
    @Input() tabHeaders: TabHeader;
    @Input() error: any;
    @Input() erroTabMap: any;
    @Output() hasFormErrorsChange: EventEmitter<{hasFormErrors: boolean}> = new EventEmitter();

    ngOnChanges(changes: SimpleChanges): void {
    }

    onAlertClose($event) {
        this.hasFormErrors = false;
        this.hasFormErrorsChange.emit({hasFormErrors: this.hasFormErrors});
    }

}